import {styled} from '@mui/material/styles'
import CircleIcon from '@mui/icons-material/Circle'

const PREFIX = 'CardComponent'

const classes = {
  root: `${PREFIX}-root`,
  text: `${PREFIX}-text`,
  box: `${PREFIX}-box`
}

const Root = styled('div')(({theme}) => ({
  [`&.${classes.root}`]: {
    padding: theme.spacing(2)
  },
  [`& .${classes.text}`]: {
    fontSize: theme.typography.h6.fontSize,
    boxSizing: 'border-box'
  },
  [`& .${classes.box}`]: {
    display: 'flex',
    width: 1,
    boxSizing: 'border-box',
    flexWrap: 'wrap',
    '& > :not(style)': {
      m: 2,
      width: 1
    }
  }
}))

export const StyledDiv = styled('div')(() => ({
  marginLeft: '16px',
  display: 'inline-flex',
  alignItems: 'center',
  boxSizing: 'border-box',
  marginTop: '10px'
}))

export const StyledCircleIcon = styled(CircleIcon)(() => ({
  height: '16px',
  boxSizing: 'border-box'
}))

export const StyledSpan = styled('span')(({theme}) => ({
  color: theme.palette.hpAccentBlack,
  fontSize: theme.typography.subtitle1.fontSize,
  lineHeight: 0.5
}))

export {Root, classes}
